import styled from "styled-components";
import customMedia from "../../config/breakpoints";

export const LayoutContainer = styled.div`
  align-items: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background ${({ theme }) => theme.colors.background};
  padding: 3rem 15rem;
  

  ${customMedia.lessThan("tablet")`
     padding: 1.2rem 5.625rem;
  `}

  ${customMedia.lessThan("mobile")`
     padding: 1.2rem 2rem;
  `}

`;
